/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsEthEquivalentTxnsFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsEthEquivalentTxnsFormat = ClosedEnum<
  typeof GetApiV3MetricsEthEquivalentTxnsFormat
>;

export type GetApiV3MetricsEthEquivalentTxnsRequest = {
  format?: GetApiV3MetricsEthEquivalentTxnsFormat | undefined;
};

/** @internal */
export const GetApiV3MetricsEthEquivalentTxnsFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsEthEquivalentTxnsFormat> = z.nativeEnum(
    GetApiV3MetricsEthEquivalentTxnsFormat,
  );

/** @internal */
export const GetApiV3MetricsEthEquivalentTxnsFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsEthEquivalentTxnsFormat> =
    GetApiV3MetricsEthEquivalentTxnsFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsEthEquivalentTxnsFormat$ {
  /** @deprecated use `GetApiV3MetricsEthEquivalentTxnsFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsEthEquivalentTxnsFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsEthEquivalentTxnsFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsEthEquivalentTxnsFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsEthEquivalentTxnsRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsEthEquivalentTxnsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  format: GetApiV3MetricsEthEquivalentTxnsFormat$inboundSchema.default("json"),
});

/** @internal */
export type GetApiV3MetricsEthEquivalentTxnsRequest$Outbound = {
  format: string;
};

/** @internal */
export const GetApiV3MetricsEthEquivalentTxnsRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsEthEquivalentTxnsRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsEthEquivalentTxnsRequest
> = z.object({
  format: GetApiV3MetricsEthEquivalentTxnsFormat$outboundSchema.default("json"),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsEthEquivalentTxnsRequest$ {
  /** @deprecated use `GetApiV3MetricsEthEquivalentTxnsRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsEthEquivalentTxnsRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsEthEquivalentTxnsRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsEthEquivalentTxnsRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsEthEquivalentTxnsRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsEthEquivalentTxnsRequest$Outbound;
}

export function getApiV3MetricsEthEquivalentTxnsRequestToJSON(
  getApiV3MetricsEthEquivalentTxnsRequest:
    GetApiV3MetricsEthEquivalentTxnsRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsEthEquivalentTxnsRequest$outboundSchema.parse(
      getApiV3MetricsEthEquivalentTxnsRequest,
    ),
  );
}

export function getApiV3MetricsEthEquivalentTxnsRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsEthEquivalentTxnsRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsEthEquivalentTxnsRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsEthEquivalentTxnsRequest' from JSON`,
  );
}
